var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 11a8 8 0 00-16 0",
    stroke: "#757779",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18v.5a2 2 0 01-2 2h-3.5M2 15.438v-1.876a2 2 0 011.515-1.94l1.74-.436a.601.601 0 01.745.582v5.463a.6.6 0 01-.746.583l-1.74-.435A2 2 0 012 15.439v-.001zm20 0v-1.876a2 2 0 00-1.515-1.94l-1.74-.436a.601.601 0 00-.745.582v5.463a.601.601 0 00.745.583l1.74-.435A2 2 0 0022 15.439v-.001z",
    stroke: "#757779",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 22h-3a1.5 1.5 0 110-3h3a1.5 1.5 0 110 3z",
    stroke: "#757779",
    strokeWidth: 1.5
  })));
}
export default SvgHelp;